import type { Components, Theme } from '@mui/material/styles';

export const cardComponents: Components<Theme> = {
    MuiCard: {
        defaultProps: {
            variant: 'outlined',
        },

        styleOverrides: {
            root: {
                borderRadius: 12,
            },
        },
    },

    MuiCardHeader: {
        styleOverrides: {
            subheader: {
                color: 'text.primary',
            },

            avatar: {
                marginLeft: 16,
                marginRight: 0,
            },
        },
    },
};